import React from 'react';

import { NumberedPagination } from '../common/pagination/NumberedPagination';
import { ProductsListItemLoading } from './ProductsListItemLoading';
import { ListContainer } from '../common/ui/ListContainer';
import { ProductsListHeader } from './ProductsListHeader';
import { ProductsListItem } from './ProductsListItem';
import { Component } from '../common/ui/Component';
import { EmptyCard } from '../common/ui/EmptyCard';

export const ProductsList = ({ isLoading, hasData, data, handlers, onReset }) => {
    if (isLoading) {
        return (
            <ListContainer>
                <ProductsListHeader />
                <Component element={ProductsListItemLoading} size={5} />
            </ListContainer>
        );
    }

    if (!hasData) {
        return (
            <ListContainer>
                <EmptyCard icon="icons" text="No results found">
                    <button type="button" className="btn btn-outline-primary" onClick={onReset}>
                        Clear filter
                    </button>
                </EmptyCard>
            </ListContainer>
        );
    }

    return (
        <ListContainer>
            <ProductsListHeader />
            {data.records.map((product) => (
                <ProductsListItem key={product.id} onRefresh={handlers.onRefresh} {...product} />
            ))}
            <NumberedPagination {...handlers} className="my-3" data={data} />
        </ListContainer>
    );
};
